import React from 'react';
import { useForm } from 'react-hook-form';
import { SwitchField } from 'components/form/rhf';

import { PartnerProfileFormValues } from '../types';
import { Stack, Typography } from '@mui/material';

interface Props {
  isLoading: boolean;
  defaultValues: PartnerProfileFormValues;
  onConfirm: (values: PartnerProfileFormValues) => Promise<void>;
}

export const PartnerProfileForm = ({ isLoading, defaultValues, onConfirm }: Props) => {
  const { control, handleSubmit } = useForm<PartnerProfileFormValues>({ defaultValues });

  return (
    <SwitchField<PartnerProfileFormValues>
      control={control}
      disabled={isLoading}
      name="availableToPro"
      label={
        <Stack>
          <Typography>Available To Pro</Typography>
          <Typography variant="caption" color="textDisabled">
            Makes this partner available for Dealers with "Pro" Aftermarket Licence Type.
          </Typography>
        </Stack>
      }
      extraAction={() => handleSubmit(onConfirm)()}
    />
  );
};
